// Global Instructions Rule Applied!
import { z } from 'zod'
import { SelectListEntrySchema, type SelectListEntry } from '../data_models/select_list_entry.ts'

const FilterOptionSchema = SelectListEntrySchema

export const TableFilterOptionsResponseSchema = z.object({
  data: z.record(z.string(), z.array(FilterOptionSchema))
})

export type FilterOption = SelectListEntry
/** Declared, not inferred — see the note on SelectListEntry about Zod 4 inferring `value?` under strictNullChecks=false. */
export type TableFilterOptionsResponse = { data: Record<string, FilterOption[]> }

export function validateFilterOptions(rpcData: Record<string, unknown>): Record<string, FilterOption[]> {
  try {
    const validated = TableFilterOptionsResponseSchema.parse({ data: rpcData })
    // The schema requires `value`; the assertion only papers over Zod 4 inferring it optional under
    // strictNullChecks=false (see the note on SelectListEntry).
    return validated.data as Record<string, FilterOption[]>
  } catch (error) {
    throw new Error(`Filter options validation failed: ${error}`)
  }
}

function createFilterResponse(rpcData: Record<string, unknown>): Record<string, FilterOption[]> {
  return validateFilterOptions(rpcData)
}
